{
  "R": [1, 240, 255],
  "G": [1, 128, 255],
  "B": [1, 128, 255],
  "A": [0, 76, 128],
  "I": [0, 153, 255]
}
